import * as i0 from '@angular/core';
import { Component, Input, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import * as i1 from 'ngx-echarts';
import { NgxEchartsModule } from 'ngx-echarts';
import * as echarts from 'echarts/core';
import { GridComponent, LegendComponent, TitleComponent, TooltipComponent } from 'echarts/components';
import { LineChart } from 'echarts/charts';
import { CanvasRenderer } from 'echarts/renderers';

class RebNgxLineChartComponent {
    // echartsInstance: any;
    constructor() {
        /**
         * defines the data of the x axis,
         * example: 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'
         */
        this.xAxisData = [];
        /**
         * defines the x axis type, by default it's defined the category,
         */
        this.xAxisType = 'category';
        /**
         * defines the y axis type, by default it's defined the value,
         */
        this.yAxisType = 'value';
        /**
         * defines the series data,
         * ex:
         * {
         *    name: 'Line Chart',
         *    data: [820, 932, 901, 934, 1290, 1330, 1320],
         *    type: 'line',
         *    lineStyle: {
         *      width: 2
         *    },
         *   areaStyle: {},
         *     emphasis: {
         *      focus: 'series'
         *   },
         *  smooth: true,
         *  },
         */
        this.seriesData = [];
        /**
         * shows the leyend of the chart,
         */
        this.showLeyend = true;
        this.colors = [
            '#3d7bf2',
            '#15de9d',
            '#ffbe75',
            '#ee6666',
            '#96baff',
            '#069a69',
            '#f79629',
            '#892cf7',
            '#ad77ee',
            '#333333'
        ];
        this.customOptions = {};
        this.options = {};
    }
    ngOnInit() {
        this.setOptions();
    }
    setOptions() {
        this.customOptions = {
            grid: {
                left: '3%',
                right: '4%',
                bottom: '3%',
                containLabel: true
            },
            tooltip: {
                trigger: 'axis',
                axisPointer: {
                    type: 'cross',
                    label: {
                        backgroundColor: '#6a7985'
                    }
                }
            },
            legend: {
                show: this.showLeyend,
                data: this.seriesData.map(({ name }) => name)
            },
            xAxis: {
                boundaryGap: false,
                type: this.xAxisType,
                data: this.xAxisData
            },
            yAxis: {
                type: this.yAxisType
            },
            series: this.seriesData
        };
        this.customOptions.color = this.colors;
        this.options = this.customOptions;
    }
}
RebNgxLineChartComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.10", ngImport: i0, type: RebNgxLineChartComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
RebNgxLineChartComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.3.10", type: RebNgxLineChartComponent, selector: "reb-ngx-line-chart", inputs: { xAxisData: "xAxisData", xAxisType: "xAxisType", yAxisType: "yAxisType", seriesData: "seriesData", showLeyend: "showLeyend" }, ngImport: i0, template: "<!-- <div echarts [options]=\"chartOptions\" (chartInit)=\"onChartInit($event)\"></div> -->\n<div echarts [autoResize]=\"true\" [options]=\"options\"></div>\n", directives: [{ type: i1.NgxEchartsDirective, selector: "echarts, [echarts]", inputs: ["options", "theme", "loading", "initOpts", "merge", "autoResize", "loadingType", "loadingOpts"], outputs: ["chartInit", "optionsError", "chartClick", "chartDblClick", "chartMouseDown", "chartMouseMove", "chartMouseUp", "chartMouseOver", "chartMouseOut", "chartGlobalOut", "chartContextMenu", "chartLegendSelectChanged", "chartLegendSelected", "chartLegendUnselected", "chartLegendScroll", "chartDataZoom", "chartDataRangeSelected", "chartTimelineChanged", "chartTimelinePlayChanged", "chartRestore", "chartDataViewChanged", "chartMagicTypeChanged", "chartPieSelectChanged", "chartPieSelected", "chartPieUnselected", "chartMapSelectChanged", "chartMapSelected", "chartMapUnselected", "chartAxisAreaSelected", "chartFocusNodeAdjacency", "chartUnfocusNodeAdjacency", "chartBrush", "chartBrushEnd", "chartBrushSelected", "chartRendered", "chartFinished"], exportAs: ["echarts"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.10", ngImport: i0, type: RebNgxLineChartComponent, decorators: [{
            type: Component,
            args: [{ selector: 'reb-ngx-line-chart', template: "<!-- <div echarts [options]=\"chartOptions\" (chartInit)=\"onChartInit($event)\"></div> -->\n<div echarts [autoResize]=\"true\" [options]=\"options\"></div>\n" }]
        }], ctorParameters: function () { return []; }, propDecorators: { xAxisData: [{
                type: Input
            }], xAxisType: [{
                type: Input
            }], yAxisType: [{
                type: Input
            }], seriesData: [{
                type: Input
            }], showLeyend: [{
                type: Input
            }] } });

echarts.use([
    CanvasRenderer,
    GridComponent,
    LegendComponent,
    LineChart,
    TitleComponent,
    TooltipComponent
]);
class RebNgxLineChartModule {
}
RebNgxLineChartModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.10", ngImport: i0, type: RebNgxLineChartModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
RebNgxLineChartModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.3.10", ngImport: i0, type: RebNgxLineChartModule, declarations: [RebNgxLineChartComponent], imports: [CommonModule, i1.NgxEchartsModule], exports: [RebNgxLineChartComponent] });
RebNgxLineChartModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.3.10", ngImport: i0, type: RebNgxLineChartModule, imports: [[CommonModule, NgxEchartsModule.forRoot({ echarts })]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.10", ngImport: i0, type: RebNgxLineChartModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [RebNgxLineChartComponent],
                    imports: [CommonModule, NgxEchartsModule.forRoot({ echarts })],
                    exports: [RebNgxLineChartComponent]
                }]
        }] });

/**
 * Generated bundle index. Do not edit.
 */

export { RebNgxLineChartComponent, RebNgxLineChartModule };
